import { defineMessages } from '@/i18n'

/** Тексты постеров и глав видео-блока. */
export const messages = defineMessages({
  ru: {
    chaptersSaveFailed: 'Не удалось сохранить главы',
    showChapters: 'Показывать главы',
    timePlaceholder: 'мм:сс',
    chapterTitle: 'Название главы',
    removeChapter: 'Удалить главу',
    addChapter: 'Добавить главу',
    posterUploadFailed: 'Не удалось загрузить постер',
    uploadPoster: 'Загрузить постер',
    loading: 'Загрузка…',
    noPosters: 'Постеров пока нет',
    active: 'Активный',
    posterSwitchFailed: 'Не удалось сменить постер',
    makeActive: 'Сделать активным',
    removePoster: 'Удалить постер',
    posterDeleteFailed: 'Не удалось удалить постер',
  },
  en: {
    chaptersSaveFailed: 'Couldn’t save chapters',
    showChapters: 'Show chapters',
    timePlaceholder: 'mm:ss',
    chapterTitle: 'Chapter title',
    removeChapter: 'Remove chapter',
    addChapter: 'Add chapter',
    posterUploadFailed: 'Couldn’t upload the poster',
    uploadPoster: 'Upload poster',
    loading: 'Loading…',
    noPosters: 'No posters yet',
    active: 'Active',
    posterSwitchFailed: 'Couldn’t change the poster',
    makeActive: 'Make active',
    removePoster: 'Delete poster',
    posterDeleteFailed: 'Couldn’t delete the poster',
  },
})
